import React, { useState } from "react";
import CustomPagination from "../../../../components/CustomPagination";
import { Box,Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Modal from "../../../../components/Modal";
import { DeleteOutlineSharp, Edit } from "@mui/icons-material";
import styles from "./style";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../../../utils/DateFormat";

const ExpenseList = ({data,deleteExpense,totalCount,page,setPage}) => {
  const [open, setOpen] = useState(false)
  const [deleteId, setDeleteId] = useState()
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const deleteData = (id) => {
    setDeleteId(id)
  }

  const handleDeleteItem = () => {
    deleteExpense(deleteId);
    setOpen(false);
  };

  return (
    <>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={styles.TableHead}>Name</TableCell>
              <TableCell sx={styles.TableHead}>Type</TableCell>
              <TableCell sx={styles.TableHead}>Amount</TableCell>
              <TableCell sx={styles.TableHead}>Date</TableCell>
              <TableCell sx={styles.TableHead}>Payment Mode</TableCell>
              <TableCell sx={styles.TableHead}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data?.expenses?.length === 0 || !data) ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  <Typography variant="h6">No data</Typography>
                </TableCell>
              </TableRow>
            ) : (
              data?.expenses?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell sx={styles.tableData}>
                    {item?.name?.length > 20 ? `${item?.name?.slice(0,20)}...`: item?.name}
                  </TableCell>
                  <TableCell sx={styles.tableData}>{item?.expType?.length > 20 ? `${item?.expType?.slice(0,20)}...`: item?.expType}</TableCell>
                  <TableCell sx={styles.tableData}>
                    {item?.amount}
                  </TableCell>
                  <TableCell sx={styles.tableData}>{formatDate(new Date(item.date), "MMM d, yyyy")}</TableCell>
                  <TableCell sx={styles.tableData}>{item?.paidVia}</TableCell>
                  <TableCell sx={styles.tableAlign}>
                    <Box>
                      <Edit onClick={() => navigate("/dashboard/viewExpense",{state:{item}})}/>
                    </Box>
                    <Box sx={{ mx: 1.5 }}>
                      <DeleteOutlineSharp
                        sx={{ color: "#ff0000" }}
                        onClick={() => {
                          deleteData(item?._id), setOpen(true);
                        }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        {data && <CustomPagination
          pageCount={totalCount}         
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          totalItems={data?.expenses?.length}
        />}
      </TableContainer>
      
      <Modal
        open={open}
        setOpen={setOpen}
        deletetText={"Delete"}
        cancelText={"Cancel"}
        title={"Delete Bank"}
        handleDelete={handleDeleteItem}
      >
        <Box>
          <Typography>Are you sure you want to Delete?</Typography>
        </Box>
      </Modal>
    </>
  );
};

export default ExpenseList;
